(function () {
    'use strict';

    if ($('.scroll-to-top').length > 0) {
        window.onscroll = function () { scrollFunction() };

        function scrollFunction() {
            var scrollPoint = 300;
            if (document.body.scrollTop > scrollPoint || document.documentElement.scrollTop > scrollPoint) {
                $('.scroll-to-top').show();
            } else {
                $('.scroll-to-top').hide();
            }
        }

        $('.scroll-to-top').on('click', function () {
            $("html, body").animate({ scrollTop: 0 }, "slow");
        });
    }
}());
